import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import type { ToggleCardBodyPropsInterface } from './types/toggle-card-body.types';

/**
 * @since 10.0.0
 */
export const ToggleCardBody = forwardRef<HTMLDivElement, ToggleCardBodyPropsInterface>(
  (props: ToggleCardBodyPropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;
    const styles = css(cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="ToggleCard.Body"
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

ToggleCardBody.displayName = 'ToggleCard.Body';
